import { useQuery, keepPreviousData as previousPlaceholder } from '@tanstack/react-query';

import { useApi } from '../contexts/ApiContext';

export function prefetchTopic(queryClient, api, slug) {
    return queryClient.prefetchQuery({
        queryKey: ['topic', slug],
        queryFn: ({ queryKey: [, slugParam], signal }) =>
            api.taxonomies.topics(
                {
                    uri: slugParam,
                },
                null,
                null,
                { signal },
            ),
    });
}

export function fetchTopic(queryClient, api, slug) {
    return queryClient.fetchQuery({
        queryKey: ['topic', slug],
        queryFn: ({ queryKey: [, slugParam], signal }) =>
            api.taxonomies.topics(
                {
                    uri: slugParam,
                },
                null,
                null,
                { signal },
            ),
    });
}

export default function useTopic(slug, opts = null) {
    const api = useApi();
    const { keepPreviousData = true } = opts || {};
    const {
        data: topic = null,
        isFetched = false,
        ...queryResult
    } = useQuery<Topic>({
        queryKey: ['topic', slug],
        queryFn: ({ queryKey: [, slugParam], signal }) =>
            api.taxonomies.topics(
                {
                    uri: slugParam,
                },
                null,
                null,
                { signal },
            ),
        suspense: false,
        placeholderData: keepPreviousData ? previousPlaceholder : null,
        ...opts,
    });

    return {
        taxonomy: topic,
        topic,
        notFound: topic === null && isFetched,
        isFetched,
        ...queryResult,
    };
}
